import { render } from "./SiteSelectorButton.vue?vue&type=template&id=470e4202&ts=true"
import script from "./SiteSelectorButton.vue?vue&type=script&lang=ts"
export * from "./SiteSelectorButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__